import axios from "axios";

export const httpAviationApim = axios.create({
    baseURL: process.env.REACT_APP_AVIATION_BASE_URL,
    headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "X-CSRF": "1",
    },
});

export const httpHiringCharterApim = axios.create({
  baseURL: process.env.REACT_APP_HIRINGCHARTER_BASE_URL,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'X-CSRF': '1',
  },
});
